import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CartItem } from '../../../../../interfaces/src/lib/types/components/cart/CartProps';
import { MyAreaCartState, PrepaidBookingPricesMyMSCResponse } from '@msc-b2c/interfaces/interfaces';

const getInitialCartUserEmail = () => {
  const stored = sessionStorage.getItem('cartUserEmail');
  if (!stored) return '';
  try {
    const parsed = JSON.parse(stored);
    return typeof parsed === 'string' ? parsed : stored;
  } catch {
    return stored;
  }
};

const initialState: MyAreaCartState = {
  items: JSON.parse(sessionStorage.getItem('cart') ?? '[]'),
  prices: null,
  loggedUserEmailInput: getInitialCartUserEmail(),
  promotionExpiredModalTriggered: false,
  appliedECoupon: sessionStorage.getItem('cartECoupon') ?? null,
  confirmation: null,
};

const myAreaCartSlice = createSlice({
  name: 'myAreaCart',
  initialState,
  reducers: {
    updateCartItems(state, action: PayloadAction<CartItem[]>) {
      state.items = action.payload;
    },
    clearCart(state) {
      state.items = [];
    },
    updateCartPrices(state, action: PayloadAction<PrepaidBookingPricesMyMSCResponse | null>) {
      state.prices = action.payload;
    },
    updateLoggedUserEmailInput(state, action: PayloadAction<string>) {
      state.loggedUserEmailInput = action.payload;
    },
    setAppliedECoupon(state, action: PayloadAction<string>) {
      state.appliedECoupon = action.payload;
    },
    clearAppliedECoupon(state) {
      state.appliedECoupon = null;
    },
    triggerPromotionExpiredModal(state, action: PayloadAction<boolean>) {
      state.promotionExpiredModalTriggered = action.payload;
    },
    prepaidConfirmation(state, action: PayloadAction<PrepaidBookingPricesMyMSCResponse | null>) {
      state.confirmation = action.payload;
    },
  },
});

export const {
  updateCartItems,
  clearCart,
  updateCartPrices,
  updateLoggedUserEmailInput,
  setAppliedECoupon,
  clearAppliedECoupon,
  triggerPromotionExpiredModal,
  prepaidConfirmation,
} = myAreaCartSlice.actions;
export default myAreaCartSlice.reducer;
